const checkLatex = function (expr1, expr2) {
   const url = "/util-getfullalgebraic.php?expr1="+encodeURIComponent(expr1)+"&expr2="+encodeURIComponent(expr2);
   return new Promise((res) => {
      jQuery.ajax({
         url,
         dataType: "json",
         type: "GET",
         success: data => res(data),
      })
   })
}

const runTests = (tests) => {
   return Promise.all(tests.map(async (test) => {
      const { latex1, latex2, sf, eq } = test;
      const check = await checkLatex(latex1, latex2);
      return { ...test, ...check };
   }));
}

const getTests = () => {
   const url = "/util-getfullalgebraic.php?tests=yes";
   return new Promise((res) => {
      $.ajax({
         url,
         dataType: "json",
         type: "GET",
         success: data => res(data),
      });
   })
}

$(document).ready(function(){

	$("#expr1").algebraicInput();
	$("#expr2").algebraicInput();

	$("#analysebutton").click(async function(){
		$("#analysis").html("");
      const expr1 = $("#expr1").algebraicInput("latex");
      const expr2 = $("#expr2").algebraicInput("latex");
      const data = await checkLatex(expr1,expr2);
      $("#analysis").append("<table class='analysis'>"
      +"<tr><td style='width:150px'><strong>Is Same Form: </strong></td><td>"+data.isSameForm+"<small><br>If a question required an expression in a particular form, then 'true' indicates a match.</small></td></tr>"
      +"<tr><td><strong>Is Equivalent: </strong></td><td>"+data.isEquiv+"<small><br>If a mark scheme said 'or any equivalent expression', true indicates a match.</small></td></tr>"
      +"<tr><td><strong>Parse1: </strong></td><td>"+beautify(data.parse1)+"</td></tr>"
      +"<tr><td><strong>Parse2: </strong></td><td>"+beautify(data.parse2)+"</td></tr>"
      +"</table>");
   });

   $('#test-button').click(async function() {
      const tests = await getTests();
      const testResults = await runTests(tests);
      $('#tests-table').append(`
         <thead>
            <th>LaTeX1</th>
            <th>LaTeX2</th>
            <th>Is Same Form</th>
            <th>Is Equivalent</th>
         </thead>
      `);
      testResults.forEach((testResult) => {
         const { latex1, latex2, parse1, parse2, isEquiv, isSameForm, sf, eq } = testResult;
         const colorOne = sf == isSameForm ? 'green' : 'red';
         const colorTwo = eq == isEquiv ? 'green' : 'red';
         $('#tests-table-body').append(`
            <tr>
            <td>${latex1}</td>
            <td>${latex2}</td>
            <td style="color: white; background-color: ${colorOne};">${isSameForm}</td>
            <td style="color: white; background-color: ${colorTwo};">${isEquiv}</td>
            </tr>
         `);
      });
      $('#test-button').prop('disabled', true);
   })
});

function beautify(json) {
   if(json==="PARSEERROR")return json;
   if(!json)return json;
   if(!json.c)return json.root;
   else {
      var str = json.root+"[";
      var ch = [];
      $.each(json.c,function(i,val){  ch.push(beautify(val)) });
      str+= ch.join(",")+"]";
      return str;
   }
}